@if (faIcon) {
  <fa-icon class="text-xs opacity-50 mr-2" [icon]="getFaIcon(faIcon)"></fa-icon>
} @else if (legacyIcon) {
  <img class="w-3 h-3 mr-2 opacity-50" [src]="getLegacyIconLink(legacyIcon)" alt="icon" />
}
